import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard/index";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Password from "../pages/Authentication/ForgetPassword";

import UserProfile from "../pages/Authentication/user-profile";
import ManageParent from "../pages/ManageParent";
import ManageChild from "../pages/manageChild";
import ManageTeacher from "../pages/ManageTeacher";
import ManageSites from "../pages/ManageSites";
import ManageTimetable from "../pages/ManageTimetable";
import Settings from "../pages/Settings";
import ManagePackage from "../pages/managePackage";
import ManagePersonalClass from "../pages/managePersonalClass";
import ManageProgram from "../pages/manageProgram";
import ManageRepeated from "../pages/manageRepeated";
import ManageProgramUnpaid from "../pages/manageProgramUnpaid";
import ManageSwap from "../pages/ManageSwap";
import ManageSurvey from "../pages/ManageSurvey";
import ManageCoupon from "../pages/ManageCoupon";
import ManageCohort from "../pages/manageCohort";
import ManageTestimonial from "../pages/ManageTestimonial";
import ManagePartner from "../pages/ManagePartner";
import ParnerDashboard from "../pages/ManagePartner/PartnerDashboard";
import PartnerParent from "../pages/ManagePartner/PartnerParent";
import PartnerChild from "../pages/ManagePartner/PartnerChild";
import PartnerProgram from "../pages/ManagePartner/PartnerProgram";
import PromoProgram from "../pages/managePromo/PromoProgram";
import PromoChild from "../pages/managePromo/PromoChild";
import PromoParent from "../pages/managePromo/PromoParent";
import PromoDashboard from "../pages/managePromo/PromoDashboard";
import ManagePartnerProgram from "../pages/managePartnerPrograms/ManagePartnerProgram";
import ManagePromo from "../pages/managePromo";
import ManagePromoProgram from "../pages/managePromoProgram/ManagePromoProgram";
import PromoTimeSlot from "../pages/managePromo/PromoTimeSlot";
import ManageBlog from "../pages/ManageBlog";
import ManageAdvert from "../pages/ManageAdvert";
import ManageTeacherView from "../pages/manageTeacherView";
import ManageReport from "../pages/ManageReport";
import ManageAttendance from "../pages/ManageAttendance";
import ManageResource from "../pages/ManageResource";

import ManageAudit from "../pages/ManageLogs";
import ManageAutoAssignment from "../pages/ManageAutoAssignment";
import ManageFaculty from "../pages/ManageFaculty";
import ManageActivities from "../pages/ManageActivities";
import ManageAdmin from "../pages/manageAdmin";
import NoProgram from "../pages/ManageParent/NoProgram";
import ManageProject from "../pages/manageProject";
import PartnerReport from "../pages/ManagePartner/PartnerReport";
import PartnerCohort from "../pages/ManagePartner/PartnerCohort";
import PartnerAccess from "../pages/ManagePartner/PartnerAccess";
import DuplicateChild from "../pages/DuplicateChild";
import AllChildrenList from "../pages/AllChildrenList";
import ManageAiDashboard from "../pages/ManageAi/Dashboard";
import ManageAiSubscriptionPlans from "../pages/ManageAi/SubscriptionPlans";
import ManageAiCurriculum from "../pages/ManageAi/Curriculum";
import ManageAiLearningPaths from "../pages/ManageAi/LearningPaths";
import ManageAiLearningPathEditor from "../pages/ManageAi/LearningPathEditor";
import ManageAiLearningPathCategories from "../pages/ManageAi/LearningPathCategories";
import ManageAiFeedback from "../pages/ManageAi/Feedback";
import ManageAiTests from "../pages/ManageAi/Tests";
import ManageAiTestEditor from "../pages/ManageAi/TestEditor";
import ManageAiTestGradeRules from "../pages/ManageAi/TestGradeRules";
import ManageAiTestAttempts from "../pages/ManageAi/TestAttempts";
import ManageAiSubscribers from "../pages/ManageAi/Subscribers";
import ManageAiClickedSubscribe from "../pages/ManageAi/ClickedSubscribe";
import ManageAiMetrics from "../pages/ManageAi/Metrics";

const userRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard />, roleType: "admin" },

  { path: "/manage-parent", component: <ManageParent />, roleType: "admin" },
  { path: "/manage-ai-parent", component: <Navigate to="/ai/parents" />, roleType: "admin" },
  { path: "/ai/dashboard", component: <ManageAiDashboard />, roleType: "admin", layout: "ai" },
  { path: "/ai/parents", component: <ManageParent />, roleType: "admin", layout: "ai" },
  { path: "/ai/subscription-plans", component: <ManageAiSubscriptionPlans />, roleType: "admin", layout: "ai" },
  { path: "/ai/subscribers", component: <ManageAiSubscribers />, roleType: "admin", layout: "ai" },
  { path: "/ai/clicked-subscribe", component: <ManageAiClickedSubscribe />, roleType: "admin", layout: "ai" },
  { path: "/ai/metrics", component: <ManageAiMetrics />, roleType: "admin", layout: "ai" },
  { path: "/ai/curriculum", component: <ManageAiCurriculum />, roleType: "admin", layout: "ai" },
  { path: "/ai/learning-paths", component: <ManageAiLearningPaths />, roleType: "admin", layout: "ai" },
  { path: "/ai/learning-path-categories", component: <ManageAiLearningPathCategories />, roleType: "admin", layout: "ai" },
  { path: "/ai/learning-paths/:id", component: <ManageAiLearningPathEditor />, roleType: "admin", layout: "ai" },
  { path: "/ai/tests", component: <ManageAiTests />, roleType: "admin", layout: "ai" },
  { path: "/ai/tests/:id", component: <ManageAiTestEditor />, roleType: "admin", layout: "ai" },
  { path: "/ai/test-grades", component: <ManageAiTestGradeRules />, roleType: "admin", layout: "ai" },
  { path: "/ai/test-attempts", component: <ManageAiTestAttempts />, roleType: "admin", layout: "ai" },
  { path: "/ai/feedback", component: <ManageAiFeedback />, roleType: "admin", layout: "ai" },
  { path: "/ai/referral-codes", component: <ManageCoupon/>, roleType: "admin", layout: "ai" },
  { path: "/manage-referral-code", component: <Navigate to="/ai/referral-codes" />, roleType: "admin" },

  { path: "/manage-child", component: <ManageChild />, roleType: "admin" },

  { path: "/duplicatechild", component: <DuplicateChild />, roleType: "admin" },

  { path: "/all-children-list", component: <AllChildrenList />, roleType: "admin" },

  { path: "/manage-teacher", component: <ManageTeacher />, roleType: "admin" },

  { path: "/manage-sites", component: <ManageSites />, roleType: "admin" },

  { path: "/manage-program", component: <ManageProgram/>, roleType: "admin" },
  { path: "/manage-personal-class", component: <ManagePersonalClass />, roleType: "admin" },

  { path: "/manage-repeated", component: <ManageRepeated/>, roleType: "admin" },

  { path: "/manage-program-unpaid", component: <ManageProgramUnpaid/>, roleType: "admin" },

  { path: "/manage-cohort", component: <ManageCohort/>, roleType: "admin" },

  { path: "/manage-timetable", component: <ManageTimetable />, roleType: "admin" },

  { path: "/manage-package", component: <ManagePackage/>, roleType: "admin" },

  { path: "/manage-swap", component: <ManageSwap/>, roleType: "admin" },

  { path: "/manage-survey", component: <ManageSurvey/>, roleType: "admin" },

  { path: "/manage-coupon", component: <ManageCoupon/>, roleType: "admin" },

  { path: "/manage-partner", component: <ManagePartner/>, roleType: "admin" },

  { path: "/manage-promo", component: <ManagePromo/>, roleType: "admin" },

  { path: "/manage-teacher-view", component: <ManageTeacherView/>, roleType: "admin" },

  { path: "/manage-auto-assignment", component: <ManageAutoAssignment/>, roleType: "admin" },

  { path: "/manage-activities", component: <ManageActivities/>, roleType: "admin" },

  { path: "/manage-report", component: <ManageReport />, roleType: "admin" },
  { path: "/manage-attendance", component: <ManageAttendance />, roleType: "admin" },
  { path: "/manage-resource", component: <ManageResource />, roleType: "admin" },
  
  { path: "/manage-testimonial", component: <ManageTestimonial/>, roleType: "admin" },

  { path: "/settings", component: <Settings />, roleType: "admin" },

  { path: "/manage-partner-program", component: <ManagePartnerProgram />, roleType: "admin" },

  { path: "/manage-promo-program", component: <ManagePromoProgram />, roleType: "admin" },

  { path: "/view-audit", component: <ManageAudit />, roleType: "admin" },

  { path: "/parent/inactive-program", component: <NoProgram />, roleType: "admin" },

   { path: "/manage-project", component: <ManageProject/>, roleType: "admin" },

  //profile
  { path: "/profile", component: <UserProfile />, roleType: "admin" },

  { path: "/manage-blog", component: <ManageBlog />, roleType: "admin" },

  { path: "/manage-advert", component: <ManageAdvert />, roleType: "admin" },

  { path: "/manage-admin", component: <ManageAdmin />, roleType: "admin" },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" />, roleType: "admin" },
];

const authRoutes = [
  //authencation page
  { path: "/auth/logout", component: <Logout /> },
  { path: "/auth/login", component: <Login /> },
  { path: "/auth/forgot", component: <Password /> },
];

const facultyRoutes = [
  //faculty page
  { path: "/faculty", component: <ManageFaculty />, roleType: "faculty" },
];

const subAdminRoutes = [
  { path: "/manage-secondary-activities", component: <ManageActivities />, roleType: "subadmin" },
];

const partnerRoutes = [
  //partner page
  { path: "/partner/dashboard/:id", component: <ParnerDashboard />, roleType: "admin" },
  { path: "/partner/manage-parent/:id", component: <PartnerParent />, roleType: "admin" },
  { path: "/partner/manage-child/:id", component: <PartnerChild />, roleType: "admin" },
  { path: "/partner/manage-program/:id", component: <PartnerProgram />, roleType: "admin" },
  { path: "/partner/manage-report/:id", component: <PartnerReport />, roleType: "admin" },
  { path: "/partner/manage-cohort/:id", component: <PartnerCohort />, roleType: "admin" },
  { path: "/partner/manage-access/:id", component: <PartnerAccess />, roleType: "admin" },
];

const promoRoutes = [
  //promo page
  { path: "/promo/dashboard/:id", component: <PromoDashboard />, roleType: "admin" },
  { path: "/promo/manage-parent/:id", component: <PromoParent />, roleType: "admin" },
  { path: "/promo/manage-child/:id", component: <PromoChild />, roleType: "admin" },
  { path: "/promo/manage-program/:id", component: <PromoProgram />, roleType: "admin" },
  { path: "/promo/manage-time/:id", component: <PromoTimeSlot />, roleType: "admin" },
];

export { userRoutes, authRoutes, partnerRoutes, promoRoutes, facultyRoutes, subAdminRoutes };
